import type { UseCase } from '@cleanpro/common-ui';
import { CreateCustomerRequest, CustomerResponse } from '../types';
import { CustomerRepository } from '../repositories/CustomerRepository';
import { Customer } from '../entities/Customer';

export class CreateCustomerUseCase implements UseCase<CreateCustomerRequest, CustomerResponse> {
  constructor(private customerRepository: CustomerRepository) {}

  async execute(request: CreateCustomerRequest): Promise<CustomerResponse> {
    // Validate business rules
    await this.validateUniqueEmail(request.email);

    // Create domain entity
    const customer = Customer.create({
      name: request.name,
      email: request.email,
      phone: request.phone,
      address: request.address,
      preferences: request.preferences
    });

    // Save to repository
    const savedCustomer = await this.customerRepository.save(customer);

    // Return DTO
    return this.toDTO(savedCustomer);
  }

  private async validateUniqueEmail(email: string): Promise<void> {
    const existingCustomer = await this.customerRepository.findByEmail(email);
    if (existingCustomer) {
      throw new Error('Customer with this email already exists');
    }
  }

  private toDTO(customer: Customer): CustomerResponse {
    return {
      id: customer.id,
      name: customer.name,
      email: customer.email,
      phone: customer.phone,
      address: customer.address,
      preferences: customer.preferences,
      rating: customer.rating,
      totalSpent: customer.totalSpent,
      lastService: customer.lastService,
      createdAt: customer.createdAt.toISOString(),
      updatedAt: customer.updatedAt.toISOString()
    };
  }
}